import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetAccessControlInfoByQrcodeId(qrcodeId) {
  return maintainRequest.get(
    `/device/common/device/getDeviceInfoByQrCodeId/${qrcodeId}`
  );
}
